module.exports = __webpack_public_path__ + "img/cw_ys_yingShouDuiZhang.b945a015.svg";